import styled from "@emotion/styled";
import { BASE_COLORS, FONT_SIZES } from "../../../../../../../../../../emotion-theme";
import { withShowIf } from "../../../../../../../../../../components/with-show-if/with-show-If.component";

export const ProductTitle = styled.h1<{ active: boolean }>`
  font-size: ${FONT_SIZES.large};
  color: ${(props) => (props.active ? BASE_COLORS.black : BASE_COLORS.red)};
`;
export const ProductBuyGetLabel = withShowIf(styled.span`
  padding: 6px;
  margin: 0 4px 0 0;
  color: ${BASE_COLORS.black};
  font-size: ${FONT_SIZES.large};
  border-radius: 10px;
  background-color: #b3b3b3;
`);
export const ProductSku = styled.span`
  color: ${BASE_COLORS.grey};
  font-size: 11px;
  &::before {
    content: " (";
  }
  &::after {
    content: ")";
  }
`;
export const HostContainer = styled.div`
  padding: 4px 0;
  width: 100%;
  text-overflow: ellipsis;
`;
export const ProductCopy = styled.div``;
